import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAchInstructions } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { pageInContext, receivingAccountDetailsLabel } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { selectAchInfoToFromAccount } from '../../../../../../create-request/reducers';
import { selectViewInContext } from 'projects/money-movement-ui/src/app/shared/reducers';
import { selectHasAccessInitiateMoneyMovement } from 'projects/money-movement-ui/src/app/authorize/reducers';

@Component({
  standalone: false,
  selector: 'mm-receiving-account-details-condensed',
  templateUrl: './receiving-account-details-condensed.component.html',
  styleUrl: './receiving-account-details-condensed.component.scss'
})
export class ReceivingAccountDetailsCondensedComponent implements OnInit{
  @Input() subtitle: string;

  readonly labels = receivingAccountDetailsLabel;

  destroy$: Subject<boolean> = new Subject<boolean>();
  amountType: string;
  accountName: string;
  accountNumber: string;
  accountType: string;
  abaNumber: string;
  nickname: string;
  financialInstitution: string;
  step: string;
  transactionType: string;

  constructor(private store: Store){
    
  }

  ngOnInit(): void {
      
    combineLatest([
      this.store.select(selectAchInstructions),
      this.store.select(selectAchInfoToFromAccount),
      this.store.select(selectViewInContext),
      this.store.select(selectHasAccessInitiateMoneyMovement)
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([instructions, toFromAccount, step, hasInitReleaseAccess]) => {
        if((hasInitReleaseAccess && !instructions?.length) || step === pageInContext.viewMsv)
        {
          this.financialInstitution = toFromAccount.financialInstitution;
          this.accountName =toFromAccount.accountName;
          this.accountNumber = toFromAccount.accountNumber ? toFromAccount.accountNumber : '';
          this.accountType = toFromAccount.accountType;
          this.abaNumber = toFromAccount.abaNumber;
          this.step = step;
        }
        else{
        instructions.forEach((instruction) => {
          this.financialInstitution = toFromAccount.financialInstitution;
          this.accountName = toFromAccount.accountName;
          this.accountNumber = toFromAccount.accountNumber ? toFromAccount.accountNumber : '';
          this.accountType = toFromAccount.accountType;
          this.abaNumber = toFromAccount.abaNumber
          this.step = step;
        });
      }
    });
  }

}